var render, staticRenderFns
import script from "./ObjectDisplay.vue?vue&type=script&lang=js&"
export * from "./ObjectDisplay.vue?vue&type=script&lang=js&"
import style0 from "./ObjectDisplay.vue?vue&type=style&index=0&id=82ae7c74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82ae7c74",
  null
  
)

export default component.exports